// extracted by mini-css-extract-plugin
export var container = "_c1-1";
export var cornerButtonContainer = "_c1-5";
export var disabled = "_c1-2";
export var fileContainer = "_c1-4";
export var hiddenInput = "_c1-3";
export var widthContainer = "_c1-0";